<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Estado fotografiado</h1>
    <mat-form-field class="full-width">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="statusPhotography">
            <mat-option *ngFor="let statusPhotography of statusPhotographies" [value]="statusPhotography">
                {{ statusPhotography.Name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="f.statusPhotography.errors && f.statusPhotography.errors.required">
            Debe seleccionar un estado
        </mat-error>
    </mat-form-field>


    <div class="clearfix">
        <div class="pull-right">
            <button [disabled]="saving" mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
        </div>
    </div>
</form>